<template>
  <b-card class="mc-modal-alert__alert-information-wrapper">
    <h4 class="title-section">
      {{ $t('notification.text.eventInfo') }}
    </h4>
    <AlertData :alert="alert" :maxVisibleGeofence="1" class="mc-modal-alert__event-data" />
    <template v-if="alert.alertCode == 151">
      <div class="row">
        <div class="col-md-12">
          <span class="text-muted font-size-12">
            {{ $t('notification.field.deliveryNumber') }}
          </span>
          <p class="font-size-13 fw-medium">
            {{ `${alertDataParts[3]?.trim().replace(/\.0$/, '')}` || '-' }}
          </p>
        </div>
        <div class="col-md-6">
          <span class="text-muted font-size-12">
            {{ $t('notification.field.actualTemp') }}
          </span>
          <p class="font-size-13 fw-medium">
            {{ `${alertDataParts[4]?.trim().replace(/\.0$/, '')} ℃` || '-' }}
          </p>
        </div>
        <div class="col-md-6">
          <span class="text-muted font-size-12">
            <span v-if="Number(alertDataParts[4]) > Number(alertDataParts[5])">
              {{ $t('notification.field.maxTempLimit') }}</span
            >
            <span v-else>{{ $t('notification.field.minTempLimit') }}</span>
          </span>
          <p class="font-size-13 fw-medium">
            {{
              alertDataParts[3]?.trim() === 'Multi DO'
                ? `${alertDataParts[3]?.trim()}`
                : `${alertDataParts[5]?.trim().replace(/\.0$/, '')} ℃` || '-'
            }}
          </p>
        </div>
      </div>
    </template>
    <div>
      <label class="label-title">{{ $t('liveView.fields.date') }}</label>
      <p>{{ momentDmMmYH(detailNotification.createdOn, true) }}</p>
    </div>
    <div>
      <label class="label-title">{{ $t('liveView.infoWindow.location') }}</label>
      <p>
        {{ address ?? '-' }}
      </p>
    </div>
    <slot />
  </b-card>
</template>
<script>
import AlertData from './AlertData.vue'
import { Helper } from '@/mixin/helper'
import { GetAddressData } from '@/services/api/map'
export default {
  components: {
    AlertData,
  },
  mixins: [Helper],
  props: {
    detailNotification: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      address: null,
    }
  },
  computed: {
    alert() {
      return {
        ...(this.detailNotification?.alert ?? {}),
        alertCode: this.detailNotification?.alert?.alertCode ?? this.detailNotification?.alertCode,
        alertData: this.detailNotification?.alert?.alertData ?? this.detailNotification?.alertData,
        alertTrigger: this.detailNotification?.alertTrigger,
        formattedAlertData: this.detailNotification?.formattedAlertData,
        speed: this.detailNotification?.speed,
        geofences: this.detailNotification?.geofences,
      }
    },
    alertDataParts() {
      return String(this.alert.alertData ?? '').split('|')
    },
    latitude() {
      return this.detailNotification?.latitude
    },
    longitude() {
      return this.detailNotification?.longitude
    },
  },
  watch: {
    latitude() {
      this.fetchAddress()
    },
    longitude() {
      this.fetchAddress()
    },
  },
  async mounted() {
    this.fetchAddress()
  },
  methods: {
    async fetchAddress() {
      if (this.latitude == null || this.longitude == null) {
        this.address = '-'
        return
      }

      try {
        const address = await GetAddressData(this.latitude, this.longitude)
        this.address = address?.display_name ?? '-'
      } catch {
        this.address = '-'
      }
    },
  },
}
</script>
